import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 満了後の扱いのENUM */
enum TreatmentAfterExpiration {
  /** 再リース */
  reLease = '1',
  /** 返却 */
  giveBack = '2',
  /** 購入 */
  purchase = '3',
  /** 廃棄 */
  discard = '4',
}

const nameConfig = {
  reLease: new Map([[Locale.ja, '再リース']]),
  giveBack: new Map([[Locale.ja, '返却']]),
  purchase: new Map([[Locale.ja, '購入']]),
  discard: new Map([[Locale.ja, '廃棄']]),
};

const toEnum = rawValueToEnum(TreatmentAfterExpiration, '');
const toDisplay = enumToName(TreatmentAfterExpiration, nameConfig);
const toDisplayWithPrefix = enumToName(TreatmentAfterExpiration, nameConfig, { prefix: true });

export const treatmentAfterExpiration = {
  enum: TreatmentAfterExpiration,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { TreatmentAfterExpiration };
